<script>
  export default {
    name: 'RenderlessComponent',
    functional: true,
    render(_, { scopedSlots }) {
      return scopedSlots.default ? scopedSlots.default() : null;
    },
  }
</script>